// extracted by mini-css-extract-plugin
export default {"inputDiv":"newFileModal_inputDiv__Xeddf","buttonDiv":"newFileModal_buttonDiv__5jGFP","okButton":"newFileModal_okButton__BtJ1I","cancelBtn":"newFileModal_cancelBtn__JcPRh"};